export const blockchainSeo = {
  title: 'Blockchain & DeFi Development Company | Rumble Fish',
  meta: [
    {
      name: 'description',
      content:
        'Rumble Fish builds DeFi protocols, DEX platforms, and Web3 products for serious blockchain projects. EVM specialists based in Europe. Talk to our team.',
    },
  ],
};
